export const showCardDefaultColumns = ({ showActions }: { showActions?: boolean }) => [
  { label: 'Status', value: 'status' },
  { label: 'Núm. do cartão', value: 'card_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Empresa', value: 'company_branch' },
  { label: 'Associado', value: 'owner_or_equipment' },
  { label: 'Solicitado em', value: 'created_at' },
  { label: 'Última atualização', value: 'updated_at' },
  { label: 'Ações', value: 'request_new_card', className: 'w-0', hidden: !showActions },
]
